import alertConfiguration from "./Configuration/index.vue";
import notificationPreferences from "./NotificationPreferences/index.vue";
import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
export default {
  components: {
    alertConfiguration,
    notificationPreferences,
    pageheader,
  },
  data() {
    return {
      dataToPreference: {},
      dataToPreferenceWithObject: {},
      input: {},
      saveLoading: false,
      isConfigValid: false,
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.input = utils.getInputContent("alertconfiguration", this.roles);
  },
  methods: {
    handleConfigUpdate(data) {
      this.dataToPreference = data;
    },
    handleConfigUpdateWithObject(data) {
      this.dataToPreferenceWithObject = data;
    },
    handleValidityChange(valid) {
      this.isConfigValid = valid;
    },
    navigateToAlertsList() {
      this.$router.push({
        path: "/alert-configuration/list",
      });
    },
    handleSave() {
      if (this.$refs.notifications) {
        this.$refs.notifications.saveAlertConfiguration();
      }
    },
    handleCancel() {
      this.$router.push({ path: "/alert-configuration/list" });
    },
  },
  beforeDestroy() {
    localStorage.removeItem("AlertPreferenceSaveObj");
    localStorage.removeItem("selectedEquipmentsChecked");
  },
};
